export const navItems = [
    {
      name: "About",
      link: "#about",
    },
    {
      name: "Impact",
      link: "#project",
    },
    {
      name: "Contact",
      link: "#contact",
    },
  ];
